<app-base-modal
  [title]="'Скачать файл с упаковками'"
>
  <mat-form-field
    appearance="outline"
    class="download-packages-excel-field"
  >
    <mat-label>Название</mat-label>
    <input
      matInput
      [(ngModel)]="fileName"
    >
  </mat-form-field>
  <app-file-progress-bar-status/>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      (click)="downloadPackagesExcel()"
    >
      Скачать
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
